import React, { SVGAttributes } from 'react'

const SvgPlayCircle = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 50 50" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width={50} height={50} fill="#48BCF6" rx={25} />
      <path
        fill="#FFF"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M22 20l9 5-9 5z"
      />
    </g>
  </svg>
)

export default SvgPlayCircle
